export const COMPANY_TYPE: { [key in string]: string } = {
  KOSPI: '코스피',
  KOSDAQ: '코스닥',
  KONEX: '코넥스',
  CORP: '일반기업',
  DEFAULT: '공공기관',
};
